import React, { useEffect } from 'react';
import { CheckCircle2, XCircle, AlertCircle, X } from 'lucide-react';

const StatusModal = ({ isOpen, type = 'success', title, message, onClose }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const config = {
        success: {
            icon: <CheckCircle2 size={40} />,
            color: 'text-green-500',
            bg: 'bg-green-50',
            shadow: 'shadow-green-100',
            button: 'bg-green-500 hover:bg-green-600 shadow-green-200'
        },
        error: {
            icon: <XCircle size={40} />,
            color: 'text-red-500',
            bg: 'bg-red-50',
            shadow: 'shadow-red-100',
            button: 'bg-red-500 hover:bg-red-600 shadow-red-200'
        },
        info: {
            icon: <AlertCircle size={40} />,
            color: 'text-primary-600',
            bg: 'bg-primary-50',
            shadow: 'shadow-primary-100',
            button: 'bg-primary-600 hover:bg-primary-700 shadow-primary-200'
        }
    };

    const current = config[type] || config.info;

    return (
        <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4">
            <div
                onClick={onClose}
                className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm"
            />

            <div
                className="relative w-full max-w-sm bg-white rounded-[2.5rem] shadow-2xl overflow-hidden border border-slate-100 p-10"
            >
                <div className="flex flex-col items-center text-center">
                    <div className={`w-20 h-20 rounded-[2rem] flex items-center justify-center mb-8 shadow-xl ${current.bg} ${current.color} ${current.shadow}`}>
                        {current.icon}
                    </div>

                    <h3 className="text-2xl font-black text-slate-800 uppercase tracking-tighter mb-3 italic">
                        {title}
                    </h3>
                    <p className="text-slate-500 font-medium mb-10 leading-relaxed">
                        {message}
                    </p>

                    <button
                        onClick={onClose}
                        className={`w-full py-5 rounded-2xl font-black text-xs uppercase tracking-[0.3em] text-black shadow-lg ${current.button}`}
                    >
                        Acknowledge
                    </button>
                </div>

                <button
                    onClick={onClose}
                    aria-label="Close modal"
                    className="absolute top-6 right-6 text-slate-300 hover:text-slate-500"
                >
                    <X size={20} />
                </button>
            </div>
        </div>
    );
};

export default StatusModal;
